import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import Typography from '@material-ui/core/Typography';
import HomeSharp from '@material-ui/icons/HomeSharp';

// Odther
import { ROUTES } from 'Console/constants/routes';

const styles = (theme) => ({
    root: {
        color: 'rgba(0, 0, 0, 0.3)',
        'font-size': 12,
        display: 'inline-flex',
        'align-items': 'center',
        'text-transform': 'capitalize',
        marginBottom: 7,
    },
    link: {
        display: 'inline-flex',
        'align-items': 'center',
        color: 'rgba(0, 0, 0, 0.3)',
        textDecoration: 'none',
    },
    icon: {
        'font-size': 16,
        color: 'rgba(0, 0, 0, 0.3)',
    },
});

const Breadcrumb = ({ classes, paths }) => {
    if (!paths) {
        return null;
    }

    return (
        <Typography variant="overline" className={classes.root}>
            <Link className={classes.link} to={ROUTES.APPLICATIONS}>
                <HomeSharp className={classes.icon} />
                &nbsp;/&nbsp;
            </Link>
            {paths.map((path, index) => {
                // Last item should not be "clickabe"
                if (paths.length - 1 === index) {
                    return path.text;
                }

                return (
                    <Link key={path.to || index} className={classes.link} to={path.to}>
                        {path.text} &nbsp;/&nbsp;
                    </Link>
                );
            })}
        </Typography>
    );
};

export default withStyles(styles)(Breadcrumb);
